const { h, render, Component } = require('preact');

class FaqsView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let landingPageFAQs = this.props.landingPageFAQs
    let faqs =
      <div class="help_with_something_else">
        <div class="need_help_with">
          {I18n.translate('js.modules.web_2018.need_help_with_something_else')}
        </div>
        <div class="help_with_something_else_buttons">
          <a class="faq1"
            href={this.props.getUrlForFAQ(landingPageFAQs[0].categoryId)}
            data-bhw="web2018_first_landing_page_faq_link">
            <p id="faq1">{landingPageFAQs[0].title}</p>
          </a>
          <a class="faq2"
            href={this.props.getUrlForFAQ(landingPageFAQs[1].categoryId)}
            data-bhw="web2018_second_landing_page_faq_link">
            <p id="faq2">{landingPageFAQs[1].title}</p>
          </a>
          <a class="faq3"
            href={this.props.getUrlForFAQ(landingPageFAQs[2].categoryId)}
            data-bhw="web2018_third_landing_page_faq_link">
            <p id="faq3">{landingPageFAQs[2].title}</p>
          </a>
          <a class="faq4"
            href={this.props.faqBaseURL}
            data-bhw="web2018_landing_page_all_faqs_link">
            <p id="faq4">{I18n.translate("js.modules.web_2018.all_faqs")}</p>
          </a>
        </div>
      </div>
    return faqs;

  }
}

module.exports = FaqsView
